import { isMobile } from 'react-device-detect'
import { selectContentSection, useAppSelector } from '@open-tender/cloud'
import { Header, HeaderLogo } from 'components'
import { Cart, NavMenu, User } from 'components/buttons'

const HeaderGuest = ({
  maxWidth = '76.8rem',
  to,
}: {
  maxWidth?: string
  to?: string
}) => {
  const { displayLogoMobile } =
    useAppSelector(selectContentSection('guest')) || {}
  const showLogo = isMobile ? displayLogoMobile : false

  return (
    <Header
      style={{ boxShadow: 'none' }}
      maxWidth={maxWidth}
      borderColor={isMobile ? 'transparent' : undefined}
      title={showLogo ? <HeaderLogo /> : undefined}
      left={isMobile ? <User /> : <HeaderLogo />}
      right={
        <>
          {!isMobile && <User to={to} />}
          <Cart />
          <NavMenu />
        </>
      }
    />
  )
}

export default HeaderGuest
